import $ from "jquery";
import Swiper from "swiper";
import ready from "../utils/ready";

document.ready().then(function () {
  let homeHeroSlider = new Swiper(".hero-swiper-container", {
    speed: 450,
    slidesPerView: 1,
    simulateTouch: true,
    allowTouchMove: true,
    grabCursor: true,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: false, 
    },
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: ".highlights-swiper-pagination",
      bulletElement: "span",
      clickable: true,
    },
  });

  let highlightsSlider = new Swiper(".highlights-swiper-container", {
    slidesPerView: 1,
    loop: true,
    centeredSlides: true,
    grabCursor: false,
    threshold: 10,
    pagination: {
      el: ".highlights-swiper-pagination",
      bulletElement: "span",
      clickable: true,
    },
    speed: 200,
    autoplay: {
      delay: 6000,
    },
  });

  highlightsSlider.on("transitionEnd", function () {
    let activeSlide = document
      .querySelector(".highlights-swiper-container")
      .querySelector(".swiper-slide-active .hidden");
    let contentDiv = document.querySelector(".highlights-active-content");
    if (activeSlide === null || contentDiv === null) {
      return false;
    }

    contentDiv.innerHTML = activeSlide.innerHTML;
  });

  let portfolioSlider = new Swiper(".portfolio-swiper-container", {
    loop: true,
    grabCursor: false,
    navigation: {
      nextEl: ".portfolio-swiper-button-next",
      prevEl: ".portfolio-swiper-button-prev",
    },
    slidesPerView: 1,
    spaceBetween: 50,
    breakpointsInverse: true,

    autoplay: {
      delay: 4000,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1200: {
        spaceBetween: 100,
        slidesPerView: 4,
      },
    },
  });

  const testimonialSwiper = new Swiper(".testimonial-swiper",  {
    speed: 450,
    slidesPerView: 1,
    simulateTouch: true,
    allowTouchMove: true,
    grabCursor: true,
    // loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: false, 
    },
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: ".testimonial-swiper-pagination",
      bulletElement: "span",
      clickable: true,
    },
  })
});

document.addEventListener("DOMContentLoaded", function () {
  const mySwiper2_wrapper = document.querySelector(".video-swiper .swiper-wrapper"),
    mySwiper_container = document.querySelector(".video-thumbs-swiper");
  const slidesCount = mySwiper2_wrapper.childNodes.length;

  // Initialize the thumbs swiper
  const swiper = new Swiper(".video-thumbs-swiper", {
    slidesPerView: 3,
    spaceBetween: 10,
    freeMode: true,
    watchSlidesProgress: true,
  });

  // Initialize the main swiper with thumbs
  const swiper2 = new Swiper(".video-swiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    loopedSlides: slidesCount,
    spaceBetween: 10,
    speed: 800,
    allowTouchMove: false,
    thumbs: {
      swiper: swiper
    },
    on: {
      slideChange: function () {
        pauseAllVideos();
        resetVideoButtons();
        clearNowPlaying();
      }
    }
  });

  // Pause all videos when a slide changes
  function pauseAllVideos() {
    document.querySelectorAll('video').forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });

    document.querySelectorAll('iframe').forEach(iframe => {
      const src = iframe.getAttribute('src');

      if (src && src.includes("youtube.com")) {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }

      if (src && src.includes("vimeo.com")) {
        iframe.contentWindow.postMessage({ method: 'pause' }, '*');
      }
    });
  }

  // Reset video buttons (visible and clickable)
  function resetVideoButtons() {
    document.querySelectorAll('.video--js').forEach(videoButton => {
      videoButton.style.opacity = "1";
      videoButton.style.pointerEvents = "auto";
    });
  }

  // Hide all "Now Playing" indicators
  function clearNowPlaying() {
    document.querySelectorAll(".video-thumbs-swiper .swiper-slide .now-playing-text").forEach(el => {
      el.style.opacity = "0"; // Hide the text
    });
  }

  // VIDEO PLAY LOGIC
  document.querySelectorAll('.video--js').forEach(videoButton => {
    videoButton.addEventListener('click', () => {
      videoButton.style.opacity = 0;
      videoButton.style.pointerEvents = 'none';

      let parent = videoButton.closest('.swiper-slide');
      let video = parent.querySelector('video');
      let iframe = parent.querySelector('iframe');

      pauseAllVideos();
      clearNowPlaying(); // Hide previous "Now Playing" labels

      let slideData = parent.getAttribute('data-slide'); // Get data-slide of current playing slide

      if (video) {
        video.play();
      } else if (iframe) {
        let src = iframe.getAttribute('src');
        if (src && !src.includes('autoplay=1')) {
          let separator = src.includes('?') ? '&' : '?';
          let newSrc = src + separator + 'autoplay=1';
          iframe.setAttribute('src', newSrc);
          iframe.dataset.playing = 'true';
        }
      }

      // Find corresponding thumbnail slide in .video-thumbs-swiper and show "Now Playing"
      if (slideData) {
        let thumbSlide = document.querySelector(`.video-thumbs-swiper .swiper-slide[data-slide="${slideData}"]`);
        if (thumbSlide) {
          let nowPlayingText = thumbSlide.querySelector(".now-playing-text");
          if (nowPlayingText) {
            nowPlayingText.style.opacity = "1"; // Show the text
          }
        }
      }
    });
  });
});





